<template>
  <button type="button" class="btn-theme-circle width-xs" :class="buttonClass"  @click="handleClick">
    <i class="mdi mdi-delete font-size-14 align-middle"></i>
  </button>
</template>
<script>
export default {
  name: 'AppButtonDeleteConfirm',
  props: {
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActivated: false,
      timer: null
    };
  },
  computed: {
    buttonClass() {
      return {
        'custom-button': true,
        'bg-danger': this.isActivated,
        'bg-soft-dark': !this.isActivated,
        [this.className]: this.className
      };
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      if (this.isActivated) {
        this.$emit('handle');
        this.resetButton();
      } else {
        this.isActivated = true;
        this.startTimer();
      }
    },
    startTimer() {
      this.timer = setTimeout(() => {
        this.resetButton();
      }, 5000);
    },
    resetButton() {
      this.isActivated = false;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
};
</script>